import { JobSpec } from './job-spec'
import { IAuditedEntity, IsoDateStr } from '@elderbyte/ngx-starter'
import { JobResult } from './job-result'
import { ErrorData } from '../orders/work-items/work-item'

export enum JobKind {
  PRIMARY = 'PRIMARY',
  SUB_TASK = 'SUB_TASK',
}

export enum JobState {
  WAITING = 'WAITING',
  RUNNING = 'RUNNING',
  AWAITING_SUBTASKS = 'AWAITING_SUB_TASKS',
  FAILED = 'FAILED',
  SUCCESS = 'SUCCESS',
}

export enum JobPriority {
  none = undefined,
  background = 10000,
  low = 1000,
  medium = 100,
  high = 1,
}

export class SubTaskOverview {
  constructor(
    public readonly total: number,
    public readonly completed: number,
    public readonly errors: number
  ) {}
}

export class Job {
  public id: string
  public state: JobState
  public priority: JobPriority

  /**
   * Specification what this job needs to do.
   */
  public spec: JobSpec

  public startedAt: IsoDateStr
  public completedAt: IsoDateStr
  public duration?: string // IsoDurationStr

  public error: ErrorData
  public subTaskOverview: SubTaskOverview
  public result: JobResult

  public audit: IAuditedEntity
}
